import React, {useEffect, useCallback, useRef} from 'react';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {Button} from '@priority-software/priority-style-react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {SAVE_EDITOR_COMMAND} from './commands';
import {IconWithPopover} from '../../components/Toolbar.parts/IconWithPopover';

interface SavePluginProps {
    onSave: () => void;
    tooltipText?: string;
    label?: string;
    disabled?: boolean;
}

export const SavePlugin: React.FC<SavePluginProps> = ({onSave, tooltipText, label, disabled}) => {
    const [editor] = useLexicalComposerContext();
    const onSaveCallbackRef = useRef(onSave);

    // Update refs when props change
    useEffect(() => {
        onSaveCallbackRef.current = onSave;
    }, [onSave]);

    // Handle save operation
    const onSaveClick = useCallback(async () => {
        editor.dispatchCommand(SAVE_EDITOR_COMMAND, undefined);
    }, [editor]);

    // Register save command
    useEffect(() => {
        const unregisterCommand = editor.registerCommand(
            SAVE_EDITOR_COMMAND,
            () => {
                if (!disabled) {
                    onSaveCallbackRef.current();
                }
                return true;
            },
            COMMAND_PRIORITY_LOW
        );

        return unregisterCommand;
    }, [editor, disabled]);

    return (
        <IconWithPopover type="children" content={tooltipText}>
            <Button
                skin="text"
                size="small"
                onClick={onSaveClick}
                style={{width: 'auto'}}
                disabled={disabled}
            >
                {label}
            </Button>
        </IconWithPopover>
    );
};
